/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ROUTE_PATHS } from '../constants';
import { useNavigate } from 'react-router-dom';
import { selectIsAuthenticated } from '../../layouts/MainLayout/slice/selectors';
import { useSelector } from 'react-redux';
import { clearAuthToken } from '../../helpers/request';

interface AuthGuardProps {
  children: React.ReactNode;
}
export default function AuthGuard({ children }: AuthGuardProps): React.ReactElement {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  useEffect(() => {
    const accessToken = localStorage.getItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
    if (!accessToken) {
      navigate(ROUTE_PATHS.LOGIN);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      clearAuthToken();
      navigate(ROUTE_PATHS.LOGIN);
    }
  }, [isAuthenticated]);

  return <>{children}</>;
}
